var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pages-dev-tenancy-company-selector-test" }, [
    _c("h3", [_vm._v("Tenancy Company Name Selector Test")]),
    _vm._v(" "),
    _c("p", { staticClass: "hint" }, [
      _vm._v(
        "\n    Compare legacy style and current restored style side-by-side.\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "compare-grid" }, [
      _c("div", { staticClass: "company-row" }, [
        _c("h4", [_vm._v("Current HKLSelect")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search__company search__company--name is-current" },
          [
            _c("HKLSelect", {
              directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
              staticClass: "seacrh__company-selector",
              attrs: {
                value: _vm.currentCompanyNameValue,
                options: _vm.companyNameHklOptions,
                showSearch: true,
                showArrow: false,
                singleTaggableInput: true,
                placeholder: "",
              },
              on: {
                search: _vm.onCurrentCompanyNameSearch,
                input: _vm.onCurrentCompanyNameInput,
                change: _vm.onCurrentCompanyNameChange,
              },
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.currentCompanyNameValue,
                  expression: "!currentCompanyNameValue",
                },
              ],
              staticClass: "fa fa-search",
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "company-row" }, [
        _c("h4", [_vm._v("Old version (e8becf9)")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search__company search__company--name is-old" },
          [
            _c("MultiSelect", {
              directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
              staticClass: "seacrh__company-selector",
              attrs: {
                required: true,
                placeholder: "",
                selectLabel: "",
                selectedLabel: "",
                deselectLabel: "",
                searchable: true,
                taggable: true,
                commitTagOnBlur: true,
                tagPlaceholder: "Add this as temporary company",
                value: _vm.legacyCompanyNameValue,
                options: _vm.companyNameOptions,
              },
              on: {
                tag: _vm.onLegacyCompanyNameChange,
                "search-change": _vm.onLegacyCompanyNameSearch,
                select: _vm.onLegacyCompanyNameChange,
              },
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.legacyCompanyNameValue,
                  expression: "!legacyCompanyNameValue",
                },
              ],
              staticClass: "fa fa-search",
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "company-row" },
      [
        _c("h4", [_vm._v("Current Trade Name (openOnFocus)")]),
        _vm._v(" "),
        _c("HKLSelect", {
          directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
          staticClass: "seacrh__company-selector",
          attrs: {
            value: _vm.currentTradeNameValue,
            options: _vm.tradeNameHklOptions,
            showSearch: true,
            showArrow: false,
            singleTaggableInput: true,
            openOnFocus: true,
            placeholder: "",
          },
          on: {
            input: _vm.onCurrentTradeNameInput,
            change: _vm.onCurrentTradeNameChange,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("pre", { staticClass: "state-debug" }, [
      _vm._v(
        _vm._s(
          JSON.stringify(
            {
              currentCompanyNameValue: _vm.currentCompanyNameValue,
              legacyCompanyNameValue: _vm.legacyCompanyNameValue,
              currentTradeNameValue: _vm.currentTradeNameValue,
            },
            null,
            2
          )
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }